// src/components/Footer.js
import React, { useEffect, useState} from 'react';
import './Footer.css';

function Footer({ location_key }) {

  const [latestUpdate, setLatestUpdate] = useState('');

  useEffect(() => {
    async function fetchLatestUpdate() {
      try {
        const apiUrl = process.env.REACT_APP_API_BASE_URI;

        const response = await fetch(apiUrl + '/last_update?location_key=' + location_key);
        const data = await response.json();
        setLatestUpdate(data);
      } catch (error) {
        console.error('Fehler beim Abrufen des letzten Updates:', error);
      }
    }

    fetchLatestUpdate();
  }, [location_key]);

  return (
    <footer className="app-footer">
      <p>© 2025 Energiewende Dashboard. Erstellt am {latestUpdate} - <a href="https://technikkultur-erfurt.de/impressum/">Impressum</a> - <a href="https://technikkultur-erfurt.de/datenschutzerklaerung/">Datenschutzerklärung</a></p>
    </footer>
  );
}

export default Footer;
